import React, { useContext, useEffect, useState } from 'react';
import { Form, Button, Card, Badge } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Datacontext } from '../../context/dataContext';
import api from "../../api";
import { motion } from "framer-motion"; // Import motion

const MarqueeManager = () => {
    const { marquee, fetchMarqee } = useContext(Datacontext);
    
    const [formData, setFormData] = useState({
        marqueeText: '',
        isLive: false 
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (marquee) {
            setFormData({ 
                marqueeText: marquee.text || "", 
                isLive: marquee.status === 'active' 
            });
        }
    }, [marquee]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!marquee?.id) {
            return Swal.fire('Error', 'No Marquee ID found', 'error');
        }

        setLoading(true);
        const payload = {
            text: formData.marqueeText.trim().toLowerCase(),
            status: formData.isLive ? 'active' : 'inactive'
        };

        try {
            await api.put(`/edit_mar/${marquee.id}`, payload);
            Swal.fire({
                icon: 'success',
                title: 'Settings Updated',
                text: `Marquee is now ${formData.isLive ? 'LIVE' : 'HIDDEN'}`,
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true
            });
            fetchMarqee();
        } catch (error) {
            Swal.fire('Error', 'Failed to update marquee status', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4" style={{ maxWidth: '600px' }}>
            <Card className="shadow-sm">
                <Card.Header className="bg-white fw-bold">Marquee Configuration</Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSave}>
                        <Form.Group className="mb-3">
                            <Form.Label>Marquee Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="marqueeText"
                                value={formData.marqueeText || ""} 
                                onChange={handleChange}
                                placeholder="Type the announcement here..."
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-4 d-flex justify-content-between align-items-center p-3 bg-light rounded">
                            <div>
                                <strong>Show Marquee on Site?</strong>
                                <div className="text-muted small">Toggle to turn marquee ON or OFF</div>
                            </div>
                            <Form.Check 
                                type="switch"
                                id="marquee-switch"
                                name="isLive"
                                checked={formData.isLive}
                                onChange={handleChange}
                                style={{ transform: 'scale(1.5)' }}
                            />
                        </Form.Group>

                        <Button variant="dark" type="submit" className="w-100" disabled={loading}>
                            {loading ? 'Processing...' : 'Update Marquee Settings'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>

            <div className="mt-4">
                <h6 className="text-muted text-uppercase small fw-bold">Current Status</h6>
                <div className="p-3 border rounded bg-white">
                    <div className="mb-2">
                        Display Status: {formData.isLive ? 
                            <Badge bg="success">ACTIVE / VISIBLE</Badge> : 
                            <Badge bg="danger">INACTIVE / HIDDEN</Badge>
                        }
                    </div>
                    
                    <div className="mt-3">
                        <small className="text-muted d-block mb-1">Live Preview:</small>
                        <div className="border p-2 overflow-hidden position-relative" style={{ minHeight: '40px', background: '#f8f9fa' }}>
                            {formData.isLive ? (
                                <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
                                    <motion.div
                                        animate={{ x: ["0%", "-50%"] }}
                                        transition={{ ease: "linear", duration: 10, repeat: Infinity }}
                                        style={{ display: 'flex' }}
                                    >
                                        <span className="text-primary fw-bold pe-5">
                                            {formData.marqueeText.toUpperCase() || 'NO TEXT ENTERED'}
                                        </span>
                                        <span className="text-primary fw-bold pe-5">
                                            {formData.marqueeText.toUpperCase() || 'NO TEXT ENTERED'}
                                        </span>
                                    </motion.div>
                                </div>
                            ) : (
                                <span className="text-muted italic small">Marquee is currently disabled. Nothing will show.</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MarqueeManager;